import { PlayerApi } from '../../communication/player-api/PlayerApi'
import { BonusInstanceResponse } from '../../communication/PlayerApiProtocol.generated'
import { createAction, hasExpired } from '../ReduxUtils'
import { ApplicationState, getStore } from '../Store'

export const REQUEST_BONUSES = 'REQUEST_BONUSES'
export const RECEIVE_BONUSES = 'RECEIVE_BONUSES'
export const BONUS_ERROR = 'BONUSE_ERROR'

export const fetchBonuses = (force?: boolean) => getStore().dispatch(_fetchBonuses(force) as any)

function _fetchBonuses(force: boolean) {
	return (dispatch, getState: () => ApplicationState) => {
		if (!hasExpired(force, getState().player.bonus, 120)) {
			return
		}
		dispatch(requestBonuses())

		PlayerApi.requestBonusInstances(
			(resp: BonusInstanceResponse[]) => {
				dispatch(receiveBonuses(resp))
			},
			() => {
				dispatch(bonusError())
			},
		)
	}
}
function requestBonuses() {
	return createAction(REQUEST_BONUSES, {})
}
function receiveBonuses(resp: BonusInstanceResponse[]) {
	return createAction(RECEIVE_BONUSES, resp)
}
function bonusError() {
	return createAction(BONUS_ERROR, {})
}
